import { useTheme } from 'styled-components';

export const GearIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.9999 9.60007V6.40009L13.838 6.25946C13.7174 5.85634 13.5567 5.46572 13.358 5.09447L14.7855 3.46696L12.5249 1.21257L10.8993 2.64319C10.528 2.44381 10.138 2.28319 9.73428 2.16319L9.59991 0H6.39992L6.26242 2.16191C5.85868 2.28066 5.46806 2.44129 5.09743 2.64191L3.47184 1.21254L1.21441 3.47189L2.64191 5.0994C2.44316 5.47065 2.28253 5.86065 2.16191 6.26376L0 6.40001V9.6L2.16191 9.7375C2.28191 10.1412 2.44316 10.5312 2.64191 10.9025L1.21755 12.5294L3.47498 14.7874L5.09865 13.3568H5.09927C5.4699 13.5562 5.8599 13.7168 6.26364 13.8368L6.39989 16H9.59987L9.7405 13.8381C10.1449 13.72 10.5355 13.5587 10.9055 13.3581L12.5292 14.7887L14.7885 12.5324L13.3548 10.9036C13.5541 10.533 13.7148 10.1424 13.8348 9.73924L15.9999 9.60007ZM7.99994 10.8638C7.24119 10.8638 6.51431 10.5619 5.97802 10.0257C5.44177 9.48943 5.14052 8.76195 5.14052 8.00313C5.14052 7.24501 5.44177 6.51751 5.97802 5.98058C6.51428 5.44433 7.24114 5.14308 7.99994 5.14246C8.75873 5.14184 9.48619 5.44246 10.0225 5.97871C10.5594 6.51434 10.8612 7.2412 10.8625 7.99998C10.8631 8.75936 10.5619 9.4881 10.025 10.0256C9.48811 10.5625 8.75936 10.8643 8.00003 10.8637L7.99994 10.8638Z"
        fill={theme.secondary.softBlue2}
      />
    </svg>
  );
};
